<template>
    <v-card class="supplier-price" outlined>
        <img class="supplier-logo" v-bind:src="supplierPrice.SupplierPrice.supplier.image" alt="">
        <p class="price-date">{{new Date(supplierPrice.SupplierPrice.created_at).toLocaleDateString() }}</p>
        <h3 class="price">${{supplierPrice.SupplierPrice.price}}</h3>
        <button @click="onShopNow()"><span class="shop-text">Shop Now</span><v-icon class="shop-icon" color="white">mdi-cart</v-icon></button>
    </v-card>
</template>

<script>
export default {
    name: 'SupplierPrice',
    props: [
        'supplierPrice'
    ],
    methods: {
        onShopNow() {
            window.open(this.supplierPrice.url);
        }
    }
}
</script>

<style lang="scss" scoped>
    .supplier-price {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100px;
        border-radius: 5px;
        padding: 0 30px;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;

     

        .supplier-logo {
            width: 25%;
            max-width: 220px;
        }

        .price-date {
            color: #707070;
            font-size: 1.4rem;
            margin: 0;
        }

        .price {
            color: #FF0000;
            font-size: 2.5rem;
        }

        button{
            background: #E79831;
            color: white;
            font-weight: bold;
            width: auto;
            padding: 5px 15px;
            border-radius: 5px !important;
            font-size: 1.2rem;

            .shop-icon {
                display: none;
            }
        }
    }

    @media screen and (max-width: 1200px) {
        .supplier-price {
            .price-date {
                display: none;
            }

            button {
                width: auto;
            }
        }
    }

    @media screen and (max-width: 600px) {
        .supplier-price {
            height: 100px;
            padding: 0 20px;

            .supplier-logo {
                width: 35%;
            }

            .price {
                color: #FF0000;
                font-size: 1.5rem;
            }

            button{
                background: #E79831;
                color: white;
                font-weight: bold;
                // width: auto;
                // float: left;
                height: auto;
                padding: 5px;
                border-radius: 5px;
                font-size: 1rem;

                .shop-text {
                    display: none;
                }

                .shop-icon {
                    display: inline-block;
                }
            }
        }
    }
</style>